import axios from 'axios';
import interceptorsSetup from '../utils/interceptors';

const axiosInstance = axios.create({
    baseURL: `https://api.tecobi.com/api/v2`,
    // baseURL: `http://dev.tecobi.com:8000/api/v2`,
    withCredentials: false, // why false?
});

// running the interceptor
interceptorsSetup(axiosInstance);

export default {
    get(url, request) {
        return axiosInstance
            .get(url, request)
            .then(response => response && response.data);
    },
    post(url, request) {
        return axiosInstance.post(url, request).then(response => response && response.data);
    },
    put(url, request) {
        return axiosInstance.put(url, request).then(response => response && response.data);
    },
    patch(url, request, config) {
        return axiosInstance.patch(url, request, config).then(response => response && response.data);
    },
    delete(url, request) {
        return axiosInstance.delete(url, request).then(response => response && response.data);
    },
    request(config) {
        return axiosInstance.request(config).then(response => response && response.data);
    },
};
